import { useQuery } from "@tanstack/react-query";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { getServicesAdmin } from "../../../network/admin";
import AntTable from "../../AntTable/AntTable";
import AvatarGroupTable from "../common/AvatarGroupTable";
type Props = {
  isFilter: any;
  selectedRowKeys: any;
  setSelectedRowKeys: any;
  searchHeader: any;
};

const TabServices = ({
  isFilter,
  selectedRowKeys,
  setSelectedRowKeys,
  searchHeader,
}: Props) => {
  const [page, setPage] = useState<number>(1);
  const { data, isLoading } = useQuery(
    ["services", page, isFilter, searchHeader],
    () => getServicesAdmin({ page, ...isFilter, search: searchHeader })
  );

  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Service name</div>
      ),
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary">
          {record?.name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon{" "}
        </div>
      ),
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary" dir="ltr">
          {record?.location?.name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Service time</div>
      ),
      dataIndex: "display_all_booking",

      render: (text: any, record) => (
        <div className="flex font-semibold text-color-primary">
          {record?.pricing_options?.map((e: any) => (
            <div>
              <span className="text-sm text-color-primary">{e?.duration}</span>
              <small className="text-color-primary text-[8px]">mins</small>
            </div>
          ))}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Team member/s</div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => <AvatarGroupTable data={record} />,
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">genders</div>,
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <span className="w-full text-sm font-medium text-color-primary">
          {record?.available_for}
        </span>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Service price</div>
      ),
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="flex font-semibold text-color-primary">
          {record?.pricing_options?.map((e: any) => (
            <div>
              <span className="text-sm text-color-primary">{e?.price}</span>
              <small className="text-color-primary text-[8px]">SR</small>
            </div>
          ))}
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer">
          <AiOutlineEdit className="text-[#9999A7]" />
        </div>
      ),
    },
  ];

  return (
    <div className="admin-catalog">
      <AntTable
        tableColumns={columns}
        tableData={data?.data}
        isLoading={isLoading}
        expandRowByClick={false}
        // hideArrowExpand
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        selectionType={selectedRowKeys}
        setPage={setPage}
        page={page}
        total={data?.meta?.total}
      />
    </div>
  );
};

export default TabServices;
